import React from 'react';
import { MessageCircle, X } from 'lucide-react';

const ChatButton = ({ onClick, unreadCount = 0, isOpen = false, hasUnread = false }) => {
  return (
    <button
      onClick={onClick}
      className={`relative flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-all duration-300 ${
        isOpen
          ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          : 'bg-primary-500 text-white hover:bg-primary-600'
      } ${hasUnread ? 'animate-pulse' : ''}`}
      style={{
        animation: hasUnread ? 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite' : 'none'
      }}
    >
      {isOpen ? (
        <X className="h-6 w-6" />
      ) : (
        <MessageCircle className="h-6 w-6" />
      )}
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center border-2 border-white">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};

export default ChatButton;
